import {LMap} from "vue2-leaflet";import {LTileLayer} from "vue2-leaflet";import
{LMarker} from "vue2-leaflet";
<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="graph" style="background-color: white">
      <network ref="network" :nodes="nodes" :edges="edges" :options="options">
      </network>
    </div>
  </div>
</template>

<script>
import { Network } from "vue2vis";

export default {
  name: "Graph",
  components: { Network },

  data() {
    return {
      data_json: json,
      nodes: [
        {
          id: 1,
          label: "przerażający",
          color: {
            background: "#eb8189",
            border: "#eb332a",
            highlight: {
              background: "#eb8189",
              border: "#eb332a",
            },
          },
          borderWidth: 2,
          borderWidthSelected: 2,
        },
        {
          id: 2,
          label: "okropny",
          color: {
            background: "#7879ff",
            border: "#3c3cff",
            highlight: {
              background: "#7879ff",
              border: "#3c3cff",
            },
          },
          borderWidth: 2,
          borderWidthSelected: 2,
        },
        {
          id: 3,
          label: "cisza",
          color: {
            background: "#eb8189",
            border: "#eb332a",
          },
        },
        {
          id: 4,
          label: "bestia",
          color: {
            background: "#eb8189",
            border: "#eb332a",
          },
        },
        {
          id: 5,
          label: "twarz",
          color: {
            background: "#eb8189",
            border: "#eb332a",
          },
        },
        {
          id: 6,
          label: "zjawisko",
          color: {
            background: "#eb8189",
            border: "#eb332a",
          },
        },
        {
          id: 7,
          label: "stan",
          color: {
            background: "#ae7eeb",
            border: "#883aeb",
          },
        },
        {
          id: 8,
          label: "głos",
          color: {
            background: "#ae7eeb",
            border: "#883aeb",
          },
        },
        {
          id: 9,
          label: "sposób",
          color: {
            background: "#ae7eeb",
            border: "#883aeb",
          },
        },
        {
          id: 10,
          label: "świat",
          color: {
            background: "#ae7eeb",
            border: "#883aeb",
          },
        },

        {
          id: 11,
          label: "los",
          color: {
            background: "#7879ff",
            border: "#3c3cff",
          },
        },
        {
          id: 12,
          label: "wrzask",
          color: {
            background: "#7879ff",
            border: "#3c3cff",
          },
        },
        {
          id: 13,
          label: "pan",
          color: {
            background: "#7879ff",
            border: "#3c3cff",
          },
        },
        {
          id: 14,
          label: "film",
          color: {
            background: "#7879ff",
            border: "#3c3cff",
          },
        },
      ],
      edges: [
        { from: 3, to: 1, width: 31 },
        { from: 4, to: 1, width: 6 },
        { from: 5, to: 1, width: 8 },
        { from: 6, to: 1, width: 9 },
        { from: 7, to: 1, width: 7 },
        { from: 8, to: 1, width: 8 },
        { from: 9, to: 1, width: 19 },
        { from: 10, to: 1, width: 27 },
        { from: 7, to: 2, width: 37 },
        { from: 8, to: 2, width: 12 },
        { from: 9, to: 2, width: 23 },
        { from: 10, to: 2, width: 10 },
        { from: 2, to: 11, width: 6 },
        { from: 2, to: 12, width: 9 },
        { from: 2, to: 13, width: 6 },
        { from: 2, to: 14, width: 6 },
      ],
      options: {
        height: "100%",
        autoResize: true,
        nodes: {
          borderWidth: 4,
          color: {
            highlight: {
              background: "#7879ff",
              border: "#3c3cff",
            },
          },
        },
        edges: {
          color: "#000000",
          length: 10,
        },
        layout: {},
        physics: {
          enabled: true,
          forceAtlas2Based: {
            theta: 0.1,
            centralGravity: 0.0,
            springConstant: 0.08,
            springLength: 100,
            damping: 0.4,
            avoidOverlap: 0,
          },
          maxVelocity: 50,
          minVelocity: 0.1,
          solver: "forceAtlas2Based",
          stabilization: {
            enabled: true,
            iterations: 2000,
            updateInterval: 100,
            onlyDynamicEdges: false,
            fit: true,
          },
          timestep: 0.1,
          adaptiveTimestep: false,
        },
      },
      all: {
        result: {
          task_id: "1f75d9b3-ab8e-4d51-b247-1272ad2db059",
          network: {
            nodes: [
              { id: 1, label: "mysz" },
              { id: 2, label: "kot" },
              { id: 3, label: "księgozbiór" },
              { id: 4, label: "życie" },
              { id: 5, label: "zapasy" },
              { id: 6, label: "tysiąc" },
              { id: 7, label: "nic" },
              { id: 8, label: "biolog" },
              { id: 9, label: "drapieżnik" },
              { id: 10, label: "kruk" },
              { id: 11, label: "Władysław" },
              { id: 12, label: "winogrono" },
              { id: 13, label: "badylarka" },
              { id: 14, label: "oko" },
              { id: 15, label: "sowa" },
              { id: 16, label: "ciemność" },
              { id: 17, label: "metoda" },
              { id: 18, label: "postać" },
              { id: 19, label: "strych" },
              { id: 20, label: "raj" },
              { id: 21, label: "teatr" },
              { id: 22, label: "radiotelegrafista" },
              { id: 23, label: "odruch" },
              { id: 24, label: "stado" },
              { id: 25, label: "futerko" },
              { id: 26, label: "wspólnota" },
              { id: 27, label: "pisk" },
              { id: 28, label: "rozstrzygnąć" },
              { id: 29, label: "raz" },
              { id: 30, label: "pajac" },
              { id: 31, label: "sfinks" },
              { id: 32, label: "irytacja" },
              { id: 33, label: "Skoczylas" },
              { id: 34, label: "ulica" },
              { id: 35, label: "przewodniczący" },
              { id: 36, label: "mnóstwo" },
              { id: 37, label: "przekład" },
              { id: 38, label: "zdarzenie" },
              { id: 39, label: "sąsiad" },
              { id: 40, label: "miasto" },
              { id: 41, label: "kobieta" },
              { id: 42, label: "lapidarność" },
              { id: 43, label: "owad" },
              { id: 44, label: "wniosek" },
              { id: 45, label: "mieszanina" },
              { id: 46, label: "M" },
              { id: 47, label: "transparent" },
              { id: 48, label: "dosiać" },
              { id: 49, label: "pies" },
              { id: 50, label: "Mikołajczyk" },
              { id: 51, label: "S" },
              { id: 52, label: "brak" },
              { id: 53, label: "stryszek" },
              { id: 54, label: "handel" },
              { id: 55, label: "skrzynia" },
              { id: 56, label: "procent" },
              { id: 57, label: "pora" },
              { id: 58, label: "Z" },
              { id: 59, label: "piesek" },
              { id: 60, label: "krzyk" },
              { id: 61, label: "zwalczać" },
              { id: 62, label: "mieszkanie" },
              { id: 63, label: "słownik" },
              { id: 64, label: "koń" },
              { id: 65, label: "zasieki" },
              { id: 66, label: "kopa" },
              { id: 67, label: "Ben" },
              { id: 68, label: "preparat" },
              { id: 69, label: "recepta" },
              { id: 70, label: "papierek" },
              { id: 71, label: "zagryźć" },
              { id: 72, label: "rząd" },
              { id: 73, label: "kisz" },
              { id: 74, label: "klient" },
              { id: 75, label: "to" },
              { id: 76, label: "mina" },
              { id: 77, label: "wydawnictwo" },
              { id: 78, label: "Turek" },
              { id: 79, label: "lato" },
              { id: 80, label: "rasa" },
              { id: 81, label: "gromada" },
              { id: 82, label: "cóż" },
              { id: 83, label: "majątek" },
              { id: 84, label: "górnik" },
              { id: 85, label: "wiadomość" },
              { id: 86, label: "szmira" },
              { id: 87, label: "sąsiadka" },
              { id: 88, label: "pośmiewisko" },
              { id: 89, label: "biegać" },
              { id: 90, label: "poprzednik" },
              { id: 91, label: "szmer" },
              { id: 92, label: "legenda" },
              { id: 93, label: "stanowisko" },
              { id: 94, label: "minister" },
              { id: 95, label: "ogród" },
              { id: 96, label: "Stanisława" },
              { id: 97, label: "współżyć" },
              { id: 98, label: "góra" },
              { id: 99, label: "okno" },
              { id: 100, label: "towarzystwo" },
              { id: 101, label: "młodzież" },
              { id: 102, label: "i tym podobne" },
              { id: 103, label: "małpa" },
              { id: 104, label: "Francuzka" },
              { id: 105, label: "kojec" },
              { id: 106, label: "jajko" },
              { id: 107, label: "sprzedawać" },
              { id: 108, label: "Michał" },
              { id: 109, label: "posada" },
              { id: 110, label: "Maria" },
              { id: 111, label: "biblioteka" },
              { id: 112, label: "rodzina" },
              { id: 113, label: "noc" },
              { id: 114, label: "Andrzej" },
              { id: 115, label: "przerwa" },
              { id: 116, label: "czas" },
              { id: 117, label: "drzwi" },
              { id: 118, label: "Stanisław" },
              { id: 119, label: "ślad" },
              { id: 120, label: "przykład" },
              { id: 121, label: "wiek" },
              { id: 122, label: "między" },
              { id: 123, label: "dziobek" },
              { id: 124, label: "mężczyzna" },
              { id: 125, label: "przyjaźń" },
              { id: 126, label: "targać" },
              { id: 127, label: "zwierzę" },
              { id: 128, label: "przejście" },
              { id: 129, label: "mundur" },
              { id: 130, label: "pelisa" },
              { id: 131, label: "doświadczenie" },
              { id: 132, label: "wierność" },
              { id: 133, label: "gaz" },
              { id: 134, label: "Ratowski" },
              { id: 135, label: "stworzenie" },
              { id: 136, label: "język" },
              { id: 137, label: "Piotr" },
              { id: 138, label: "szkoda" },
              { id: 139, label: "gonitwa" },
              { id: 140, label: "rozmiar" },
              { id: 141, label: "ryba" },
              { id: 142, label: "drzemka" },
              { id: 143, label: "ściana" },
              { id: 144, label: "działalność" },
              { id: 145, label: "wydawca" },
              { id: 146, label: "byt" },
              { id: 147, label: "izba" },
              { id: 148, label: "walka" },
              { id: 149, label: "pazurek" },
              { id: 150, label: "ruchomość" },
              { id: 151, label: "słowo" },
              { id: 152, label: "zachować" },
              { id: 153, label: "szczur" },
              { id: 154, label: "ptak" },
              { id: 155, label: "schodek" },
              { id: 156, label: "wycieczka" },
              { id: 157, label: "klatka" },
              { id: 158, label: "podróż" },
              { id: 159, label: "mysz" },
              { id: 160, label: "plaga" },
              { id: 161, label: "pszenica" },
              { id: 162, label: "wywracać" },
              { id: 163, label: "Mieczysław" },
              { id: 164, label: "wynik" },
              { id: 165, label: "Mac" },
              { id: 166, label: "wyścig" },
              { id: 167, label: "świat" },
              { id: 168, label: "lalka" },
              { id: 169, label: "Günter" },
              { id: 170, label: "węgiel" },
              { id: 171, label: "klęska" },
              { id: 172, label: "Kazimierz" },
              { id: 173, label: "działanie" },
              { id: 174, label: "nerwowość" },
              { id: 175, label: "Mar" },
              { id: 176, label: "teatrzyk" },
              { id: 177, label: "gryzoń" },
              { id: 178, label: "dom" },
              { id: 179, label: "towarzysz" },
              { id: 180, label: "zabawa" },
              { id: 181, label: "Stroński" },
              { id: 182, label: "wstęp" },
              { id: 183, label: "chwila" },
              { id: 184, label: "sekunda" },
              { id: 185, label: "próba" },
              { id: 186, label: "dostęp" },
              { id: 187, label: "ambasador" },
              { id: 188, label: "pani" },
              { id: 189, label: "zakup" },
              { id: 190, label: "pożreć" },
              { id: 191, label: "karaluch" },
              { id: 192, label: "woda" },
              { id: 193, label: "Ferdynand" },
              { id: 194, label: "złoto" },
              { id: 195, label: "pułapka" },
              { id: 196, label: "ląd" },
              { id: 197, label: "Janerka" },
              { id: 198, label: "komar" },
              { id: 199, label: "zanik" },
              { id: 200, label: "Polska" },
              { id: 201, label: "wyjątek" },
              { id: 202, label: "Japończyk" },
              { id: 203, label: "Ala" },
              { id: 204, label: "pensjonat" },
              { id: 205, label: "pewność" },
              { id: 206, label: "słój" },
              { id: 207, label: "dziecko" },
              { id: 208, label: "ogon" },
              { id: 209, label: "zając" },
              { id: 210, label: "lament" },
              { id: 211, label: "rzeczywistość" },
              { id: 212, label: "starożytność" },
              { id: 213, label: "sprawa" },
              { id: 214, label: "reszta" },
              { id: 215, label: "Grass" },
              { id: 216, label: "dach" },
              { id: 217, label: "kot" },
              { id: 218, label: "kolega" },
              { id: 219, label: "rozmowa" },
              { id: 220, label: "talent" },
              { id: 221, label: "szafa" },
              { id: 222, label: "nornik" },
              { id: 223, label: "plew" },
              { id: 224, label: "zasługa" },
              { id: 225, label: "część" },
              { id: 226, label: "delegacja" },
              { id: 227, label: "ksiądz" },
              { id: 228, label: "powinowactwo" },
              { id: 229, label: "chata" },
              { id: 230, label: "profesor" },
              { id: 231, label: "moda" },
              { id: 232, label: "ładunek" },
              { id: 233, label: "sąd" },
              { id: 234, label: "kupować" },
              { id: 235, label: "bóg" },
              { id: 236, label: "chomik" },
              { id: 237, label: "szosa" },
              { id: 238, label: "sanki" },
              { id: 239, label: "boj" },
              { id: 240, label: "hodowla" },
              { id: 241, label: "tępiciel" },
              { id: 242, label: "miejsce" },
              { id: 243, label: "stóg" },
              { id: 244, label: "dziewczynka" },
              { id: 245, label: "murek" },
              { id: 246, label: "ugór" },
              { id: 247, label: "link" },
              { id: 248, label: "Gopło" },
              { id: 249, label: "żaba" },
              { id: 250, label: "odwracać" },
              { id: 251, label: "rok" },
              { id: 252, label: "wąż" },
              { id: 253, label: "staruszka" },
              { id: 254, label: "para" },
              { id: 255, label: "odwrócenie" },
              { id: 256, label: "DDT" },
              { id: 257, label: "promień" },
              { id: 258, label: "najdroższy" },
              { id: 259, label: "zarobek" },
              { id: 260, label: "temat" },
              { id: 261, label: "organizm" },
              { id: 262, label: "na przykład" },
              { id: 263, label: "dawka" },
              { id: 264, label: "łapka" },
              { id: 265, label: "Fredro" },
              { id: 266, label: "głowa" },
              { id: 267, label: "kraj" },
              { id: 268, label: "więź" },
              { id: 269, label: "narysować" },
              { id: 270, label: "robota" },
              { id: 271, label: "istota" },
              { id: 272, label: "mózg" },
              { id: 273, label: "królik" },
              { id: 274, label: "rybka" },
              { id: 275, label: "Jan" },
              { id: 276, label: "marzec" },
              { id: 277, label: "mistrz" },
              { id: 278, label: "akcja" },
              { id: 279, label: "seria" },
              { id: 280, label: "suknia" },
            ],
            edges: [
              { width: 1, from: 3, to: 1 },
              { width: 2, from: 4, to: 2 },
              { width: 1, from: 5, to: 1 },
              { width: 1, from: 6, to: 1 },
              { width: 1, from: 6, to: 2 },
              { width: 1, from: 7, to: 2 },
              { width: 1, from: 8, to: 2 },
              { width: 1, from: 9, to: 2 },
              { width: 1, from: 10, to: 2 },
              { width: 1, from: 11, to: 2 },
              { width: 1, from: 12, to: 1 },
              { width: 1, from: 13, to: 1 },
              { width: 1, from: 14, to: 1 },
              { width: 2, from: 15, to: 1 },
              { width: 1, from: 16, to: 2 },
              { width: 1, from: 17, to: 1 },
              { width: 1, from: 17, to: 2 },
              { width: 1, from: 18, to: 1 },
              { width: 1, from: 19, to: 2 },
              { width: 1, from: 20, to: 1 },
              { width: 2, from: 21, to: 2 },
              { width: 1, from: 22, to: 2 },
              { width: 1, from: 23, to: 2 },
              { width: 1, from: 24, to: 1 },
              { width: 1, from: 25, to: 1 },
              { width: 1, from: 26, to: 1 },
              { width: 1, from: 27, to: 1 },
              { width: 1, from: 28, to: 2 },
              { width: 1, from: 29, to: 2 },
              { width: 1, from: 30, to: 2 },
              { width: 1, from: 31, to: 2 },
              { width: 1, from: 32, to: 2 },
              { width: 1, from: 33, to: 2 },
              { width: 1, from: 34, to: 2 },
              { width: 2, from: 35, to: 2 },
              { width: 1, from: 36, to: 1 },
              { width: 1, from: 37, to: 1 },
              { width: 1, from: 38, to: 2 },
              { width: 1, from: 39, to: 2 },
              { width: 1, from: 40, to: 2 },
              { width: 1, from: 41, to: 2 },
              { width: 1, from: 42, to: 2 },
              { width: 1, from: 43, to: 1 },
              { width: 1, from: 44, to: 1 },
              { width: 1, from: 45, to: 2 },
              { width: 3, from: 46, to: 2 },
              { width: 1, from: 47, to: 2 },
              { width: 1, from: 48, to: 1 },
              { width: 43, from: 49, to: 2 },
              { width: 1, from: 50, to: 2 },
              { width: 1, from: 51, to: 2 },
              { width: 1, from: 52, to: 2 },
              { width: 1, from: 53, to: 2 },
              { width: 1, from: 54, to: 2 },
              { width: 1, from: 55, to: 1 },
              { width: 1, from: 56, to: 1 },
              { width: 1, from: 57, to: 1 },
              { width: 1, from: 57, to: 2 },
              { width: 1, from: 58, to: 2 },
              { width: 1, from: 59, to: 2 },
              { width: 1, from: 60, to: 2 },
              { width: 1, from: 61, to: 1 },
              { width: 1, from: 62, to: 2 },
              { width: 1, from: 63, to: 2 },
              { width: 1, from: 64, to: 2 },
              { width: 1, from: 65, to: 1 },
              { width: 1, from: 66, to: 2 },
              { width: 1, from: 67, to: 1 },
              { width: 1, from: 68, to: 1 },
              { width: 1, from: 69, to: 2 },
              { width: 1, from: 70, to: 2 },
              { width: 1, from: 71, to: 2 },
              { width: 1, from: 72, to: 1 },
              { width: 2, from: 73, to: 1 },
              { width: 1, from: 74, to: 2 },
              { width: 3, from: 75, to: 1 },
              { width: 3, from: 75, to: 2 },
              { width: 1, from: 76, to: 2 },
              { width: 4, from: 77, to: 2 },
              { width: 1, from: 78, to: 2 },
              { width: 1, from: 79, to: 1 },
              { width: 1, from: 80, to: 2 },
              { width: 1, from: 81, to: 2 },
              { width: 1, from: 82, to: 2 },
              { width: 1, from: 83, to: 2 },
              { width: 1, from: 84, to: 2 },
              { width: 1, from: 85, to: 2 },
              { width: 1, from: 86, to: 1 },
              { width: 1, from: 87, to: 2 },
              { width: 1, from: 88, to: 1 },
              { width: 1, from: 89, to: 1 },
              { width: 1, from: 90, to: 2 },
              { width: 1, from: 91, to: 1 },
              { width: 1, from: 92, to: 1 },
              { width: 1, from: 93, to: 1 },
              { width: 1, from: 94, to: 2 },
              { width: 1, from: 95, to: 1 },
              { width: 1, from: 96, to: 2 },
              { width: 1, from: 97, to: 2 },
              { width: 8, from: 98, to: 1 },
              { width: 1, from: 98, to: 2 },
              { width: 1, from: 99, to: 2 },
              { width: 1, from: 100, to: 2 },
              { width: 1, from: 101, to: 2 },
              { width: 1, from: 102, to: 1 },
              { width: 2, from: 103, to: 1 },
              { width: 1, from: 104, to: 2 },
              { width: 1, from: 105, to: 2 },
              { width: 1, from: 106, to: 2 },
              { width: 1, from: 107, to: 2 },
              { width: 1, from: 108, to: 2 },
              { width: 1, from: 109, to: 1 },
              { width: 1, from: 110, to: 2 },
              { width: 1, from: 111, to: 2 },
              { width: 3, from: 112, to: 2 },
              { width: 2, from: 113, to: 2 },
              { width: 1, from: 114, to: 2 },
              { width: 1, from: 115, to: 2 },
              { width: 1, from: 116, to: 2 },
              { width: 1, from: 117, to: 1 },
              { width: 4, from: 118, to: 2 },
              { width: 1, from: 119, to: 2 },
              { width: 1, from: 120, to: 1 },
              { width: 1, from: 120, to: 2 },
              { width: 1, from: 121, to: 1 },
              { width: 2, from: 122, to: 2 },
              { width: 1, from: 123, to: 2 },
              { width: 1, from: 124, to: 1 },
              { width: 1, from: 125, to: 2 },
              { width: 1, from: 126, to: 2 },
              { width: 1, from: 127, to: 1 },
              { width: 1, from: 127, to: 2 },
              { width: 1, from: 128, to: 2 },
              { width: 1, from: 129, to: 1 },
              { width: 1, from: 130, to: 2 },
              { width: 2, from: 131, to: 1 },
              { width: 1, from: 132, to: 2 },
              { width: 1, from: 133, to: 2 },
              { width: 1, from: 134, to: 2 },
              { width: 1, from: 135, to: 1 },
              { width: 1, from: 136, to: 2 },
              { width: 1, from: 137, to: 2 },
              { width: 1, from: 138, to: 1 },
              { width: 1, from: 139, to: 1 },
              { width: 1, from: 140, to: 1 },
              { width: 2, from: 141, to: 2 },
              { width: 1, from: 142, to: 2 },
              { width: 1, from: 143, to: 1 },
              { width: 1, from: 144, to: 2 },
              { width: 1, from: 145, to: 2 },
              { width: 1, from: 146, to: 1 },
              { width: 1, from: 147, to: 1 },
              { width: 1, from: 148, to: 1 },
              { width: 1, from: 149, to: 2 },
              { width: 1, from: 150, to: 2 },
              { width: 2, from: 151, to: 2 },
              { width: 1, from: 152, to: 2 },
              { width: 7, from: 153, to: 1 },
              { width: 1, from: 153, to: 2 },
              { width: 2, from: 154, to: 1 },
              { width: 1, from: 155, to: 2 },
              { width: 1, from: 156, to: 2 },
              { width: 1, from: 157, to: 1 },
              { width: 1, from: 158, to: 1 },
              { width: 1, from: 158, to: 2 },
              { width: 2, from: 159, to: 1 },
              { width: 2, from: 159, to: 2 },
              { width: 6, from: 160, to: 1 },
              { width: 1, from: 161, to: 1 },
              { width: 2, from: 162, to: 2 },
              { width: 1, from: 163, to: 2 },
              { width: 3, from: 164, to: 1 },
              { width: 1, from: 165, to: 1 },
              { width: 1, from: 166, to: 1 },
              { width: 2, from: 167, to: 2 },
              { width: 1, from: 168, to: 1 },
              { width: 1, from: 169, to: 2 },
              { width: 1, from: 170, to: 2 },
              { width: 1, from: 171, to: 1 },
              { width: 1, from: 172, to: 2 },
              { width: 1, from: 173, to: 1 },
              { width: 1, from: 174, to: 2 },
              { width: 1, from: 175, to: 2 },
              { width: 3, from: 176, to: 2 },
              { width: 1, from: 177, to: 1 },
              { width: 3, from: 178, to: 2 },
              { width: 2, from: 179, to: 2 },
              { width: 1, from: 180, to: 1 },
              { width: 1, from: 181, to: 2 },
              { width: 2, from: 182, to: 2 },
              { width: 1, from: 183, to: 2 },
              { width: 1, from: 184, to: 1 },
              { width: 1, from: 185, to: 2 },
              { width: 1, from: 186, to: 1 },
              { width: 1, from: 187, to: 2 },
              { width: 1, from: 188, to: 2 },
              { width: 1, from: 189, to: 2 },
              { width: 1, from: 190, to: 1 },
              { width: 1, from: 191, to: 1 },
              { width: 1, from: 192, to: 2 },
              { width: 1, from: 193, to: 2 },
              { width: 1, from: 194, to: 2 },
              { width: 4, from: 195, to: 1 },
              { width: 1, from: 196, to: 2 },
              { width: 1, from: 197, to: 2 },
              { width: 1, from: 198, to: 1 },
              { width: 1, from: 199, to: 2 },
              { width: 1, from: 200, to: 2 },
              { width: 1, from: 201, to: 2 },
              { width: 1, from: 202, to: 2 },
              { width: 5, from: 203, to: 2 },
              { width: 1, from: 204, to: 2 },
              { width: 1, from: 205, to: 1 },
              { width: 1, from: 206, to: 1 },
              { width: 3, from: 207, to: 2 },
              { width: 11, from: 208, to: 2 },
              { width: 1, from: 209, to: 1 },
              { width: 1, from: 209, to: 2 },
              { width: 1, from: 210, to: 2 },
              { width: 1, from: 211, to: 2 },
              { width: 1, from: 212, to: 2 },
              { width: 1, from: 213, to: 1 },
              { width: 2, from: 213, to: 2 },
              { width: 1, from: 214, to: 2 },
              { width: 1, from: 215, to: 2 },
              { width: 1, from: 216, to: 2 },
              { width: 5, from: 217, to: 1 },
              { width: 1, from: 218, to: 2 },
              { width: 1, from: 219, to: 2 },
              { width: 2, from: 220, to: 2 },
              { width: 1, from: 221, to: 2 },
              { width: 2, from: 222, to: 1 },
              { width: 1, from: 223, to: 2 },
              { width: 1, from: 224, to: 2 },
              { width: 1, from: 225, to: 1 },
              { width: 1, from: 226, to: 2 },
              { width: 1, from: 227, to: 2 },
              { width: 1, from: 228, to: 2 },
              { width: 1, from: 229, to: 2 },
              { width: 1, from: 230, to: 2 },
              { width: 1, from: 231, to: 2 },
              { width: 1, from: 232, to: 2 },
              { width: 2, from: 233, to: 2 },
              { width: 2, from: 234, to: 2 },
              { width: 1, from: 235, to: 2 },
              { width: 1, from: 236, to: 1 },
              { width: 1, from: 237, to: 2 },
              { width: 1, from: 238, to: 1 },
              { width: 2, from: 239, to: 2 },
              { width: 1, from: 240, to: 1 },
              { width: 1, from: 241, to: 1 },
              { width: 1, from: 241, to: 2 },
              { width: 1, from: 242, to: 1 },
              { width: 1, from: 243, to: 1 },
              { width: 1, from: 244, to: 2 },
              { width: 1, from: 245, to: 2 },
              { width: 1, from: 246, to: 2 },
              { width: 1, from: 247, to: 2 },
              { width: 1, from: 248, to: 1 },
              { width: 1, from: 249, to: 1 },
              { width: 2, from: 250, to: 2 },
              { width: 1, from: 251, to: 2 },
              { width: 1, from: 252, to: 2 },
              { width: 1, from: 253, to: 2 },
              { width: 1, from: 254, to: 1 },
              { width: 1, from: 255, to: 2 },
              { width: 1, from: 256, to: 1 },
              { width: 1, from: 257, to: 1 },
              { width: 1, from: 258, to: 2 },
              { width: 1, from: 259, to: 2 },
              { width: 1, from: 260, to: 2 },
              { width: 1, from: 261, to: 2 },
              { width: 1, from: 262, to: 2 },
              { width: 1, from: 263, to: 2 },
              { width: 1, from: 264, to: 1 },
              { width: 1, from: 265, to: 1 },
              { width: 1, from: 266, to: 2 },
              { width: 1, from: 267, to: 2 },
              { width: 1, from: 268, to: 2 },
              { width: 1, from: 269, to: 2 },
              { width: 1, from: 270, to: 2 },
              { width: 1, from: 271, to: 2 },
              { width: 2, from: 272, to: 2 },
              { width: 2, from: 273, to: 2 },
              { width: 1, from: 274, to: 2 },
              { width: 5, from: 275, to: 2 },
              { width: 1, from: 276, to: 2 },
              { width: 1, from: 277, to: 2 },
              { width: 1, from: 278, to: 2 },
              { width: 1, from: 279, to: 2 },
              { width: 1, from: 280, to: 2 },
            ],
          },
        },
        Totaltime: 0.212,
        id: "1f75d9b3-ab8e-4d51-b247-1272ad2db059",
        time: 0.208,
        error: "",
      },
    };
  },
  methods: {
    showGraph: function () {
      let a = 0;
      let b = 0;

      this.edges = this.data_json.result.network.edges.slice(0, 10);

      this.nodes = this.data_json.result.network.nodes.slice(0, 10);
    },
  },
  mounted() {
    this.showGraph();
  },
};
</script>

<style scoped>
h2 {
  color: #3d5c99;
}
#about {
  height: 100%;
  overflow: auto;
  text-align: justify;
  padding: 20px;
}
.about-title {
  margin-top: 2rem;
  height: 2rem;
  justify-content: center;
  background-color: var(--grey_dark1);
}
.about-title h2 {
  height: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  text-transform: uppercase;
  color: var(--white_grey);
  font-size: 1.5rem;
}
.about-content {
  padding-top: 10px;
}
.graph {
  width: 100%;
  height: 100%;
}
@media only screen and (min-width: 768px) {
  .about-fit {
    width: 700px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Graph.vue